import { Search, UserPlus } from "react-feather";
import Button from "../../components/input/Button";
import { FORMS, MODULES } from "../../const";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import {
  findAll,
  masterShiftSearch,
  searchAssignmentData,
} from "../../api/shiftAssignmentApi";
import Dropdown from "../../components/input/Dropdown";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import { Card, CardContent } from "@mui/material";
import { errorActions } from "../../store/error-slice";
import { searchCallCenterPerformanceReport } from "../../api/callCenterReportApi";
import {
  DateOnlyCellRenderer,
  ResizableScrollingTextRenderer,
} from "../../components/renderer/StyleRenderer";
import useUserCompany from "../../hooks/useUserCompany";

const CallCenterPerformance = () => {
  const [tab, setTab] = useState(1);

  const [searchClicked, setSearchClicked] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const [dateType, setDateType] = useState(1);
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [user, setUser] = useState(null);
  const [stk, setStk] = useState(null);
  const [shift, setShift] = useState(null);
  const [actionPoint, setActionPoint] = useState(null);

  const [shiftOptions, setShiftOptions] = useState([]);
  const [actionOptions, setActionOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState(null);
  const [activeOptions, setActiveOptions] = useState(null);

  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);

  const userCompany = useUserCompany();
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  useEffect(() => {
    (async () => {
      setIsSearchLoading(true);
      const { active, status } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);

      const actionStatusData = await getOtherRefSearchDropdown({
        type: "shift_action",
        param1: "",
      });
      const updatedActionStatusData = actionStatusData.map(
        (actionStatusData) => {
          return {
            ...actionStatusData,
            text: actionStatusData.title,
          };
        }
      );
      console.log("updatedActionStatusData", updatedActionStatusData);
      setActionOptions(updatedActionStatusData);

      const shiftData = await findAll();
      const updatedShiftData = shiftData.map((shiftData) => {
        return {
          ...shiftData,
          text: shiftData.title,
        };
      });
      console.log("shiftData-", updatedShiftData);
      console.log("ActiveData-", active);
      setShiftOptions(updatedShiftData);
      setIsSearchLoading(false);
    })();
  }, []);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (tab === 1) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchCallCenterPerformanceReport({
      fromDate: fromDate,
      toDate: toDate,
      shift: shift,
      actionPoint: actionPoint,
      user: user,
      stakeholder: stk,
      status: status,
      active: active,
      company: company,
    });
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };

  const handleSearchReset = (e) => {
    e.preventDefault();
    setFromDate(new Date().toISOString().split("T")[0]);
    setToDate(new Date().toISOString().split("T")[0]);
    setStatus(null);
    setActive(null);
    setUser(null);
    setStk(null);
    setActionPoint(null);
  };

  const handleReset = (e) => {
    e.preventDefault();
  };

  const callCenterGridConfig = [
    {
      field: "username",
      headerName: "User",
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    { field: "shiShift", headerName: "Shift" },
    {
      field: "stkName",
      headerName: "Customer",
      cellRenderer: ResizableScrollingTextRenderer,
    },
    { field: "rstCode", headerName: "Action Point" },
    {
      field: "createdDate",
      headerName: "Action Date",
      cellRenderer: DateOnlyCellRenderer,
    },
    { field: "possibleHits", headerName: "Possible Hits" },
    { field: "within30mShift", headerName: "Within 30m for Shift" },
    { field: "after30mShift", headerName: "After 30m for Shift" },
    { field: "shiftPercent", headerName: "Shift %" },
    { field: "within30mOutShift", headerName: "Within 30m Out of Shift" },
    { field: "after30mOutShift", headerName: "After 30m Out of Shift" },
    { field: "arrivalConfirmation", headerName: "Arrival Confirmation" },
    { field: "jobFlag", headerName: "Job Flags" },
    { field: "totalActions", headerName: "Total Hits" },
  ];

  return (
    <>
      <Card className="stakeholder-card-container">
        <CardContent>
          <div
            className="ui attached tabular"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="ui tabular menu attached">
              <div
                className={`item ${tab === 1 ? "active" : ""}`}
                onClick={() => {
                  setTab(1);
                }}
              >
                <span>
                  <UserPlus size={15} style={{ marginRight: "5px" }} />
                </span>
                Call Center Search
              </div>
            </div>
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 1 ? "block" : "none" }}
          >
            <div className="ui styled accordion" style={{ width: "100%" }}>
              <div
                className={`title ${activeAccordion1 ? "active" : ""}`}
                onClick={() => setActiveAccordion1(!activeAccordion1)}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <span>Search</span>
                    <Search size={14} style={{ marginLeft: "10px" }} />
                    <i className="dropdown icon"></i>
                  </div>

                  <i
                    className="refresh icon primary button"
                    style={{
                      display: `${resetVisible ? "flex" : "none"}`,
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      handleReset(e);
                    }}
                  ></i>
                </div>
              </div>
              <div className={`content ${activeAccordion1 ? "active" : ""}`}>
                {isSearchLoading ? (
                  <LoadingSpinner />
                ) : (
                  <form className="ui form">
                    <h4 className="ui dividing header"></h4>
                    <div className="four fields">
                      <Input
                        label="From Date"
                        type="date"
                        name="fromDate"
                        value={fromDate}
                        max={toDate ?? new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          setFromDate(e.target.value);
                        }}
                      />
                      <Input
                        label={"To Date"}
                        type="date"
                        name="toDate"
                        value={toDate}
                        min={fromDate}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          setToDate(e.target.value);
                        }}
                      />
                      <Dropdown
                        required={true}
                        options={shiftOptions}
                        label="Shift"
                        placeholder="Shift"
                        style={{ height: "20px" }}
                        value={dateType}
                        onChange={(e, data) => {
                          setShift(data.value);
                        }}
                        clearable={true}
                      />
                      <Dropdown
                        required={true}
                        options={actionOptions}
                        label="Action Point"
                        placeholder="Action Point"
                        style={{ height: "20px" }}
                        value={actionPoint}
                        onChange={(e, data) => {
                          setActionPoint(data.value);
                        }}
                        clearable={true}
                      />
                    </div>
                    <div className="four fields">
                      <SearchDropdown
                        key={1}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        clearable={true}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "shift_users",
                          value: "",
                        }}
                        onResultSelect={(data) => setUser(data)}
                        onClear={() => {
                          setUser(null);
                        }}
                        label="User"
                        field="req_behalf_of"
                      />
                      <SearchDropdown
                        key={1}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        clearable={true}
                        onClear={() => {
                          setStk(null);
                        }}
                        onResultSelect={(data) => setStk(data)}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Customer",
                        }}
                        label="Stakeholder"
                      />
                      <Dropdown
                        label="Status"
                        options={statusOptions}
                        placeholder="Status"
                        style={{ height: "20px" }}
                        value={status}
                        onChange={(e, data) => {
                          setStatus(data.value);
                        }}
                        clearable={true}
                      />
                      <Dropdown
                        label="Active"
                        options={activeOptions}
                        placeholder="Active"
                        style={{ height: "20px" }}
                        value={active}
                        onChange={(e, data) => {
                          setActive(data.value);
                        }}
                        clearable={true}
                      />
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="field" style={{ width: "100%" }}>
                        <Button
                          template="search"
                          onClick={(e) => {
                            handleSearchSubmit(e);
                          }}
                        />
                        <Button
                          template="searchReset"
                          onClick={(e) => {
                            handleSearchReset(e);
                          }}
                        />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
          {searchClicked &&
            (searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Grid
                  heading="Call Center Performance"
                  downloadParam={""}
                  downloadAction="Call Center Performance Excel Download"
                  content={searchRes}
                  config={callCenterGridConfig}
                  pagination={true}
                  multiRowSelection={true}
                  showDownloadButton={true}
                  downloadOnlySelected={true}
                  reportName="call_center_report.csv"
                />
              </>
            ))}
        </CardContent>
      </Card>
    </>
  );
};
export default CallCenterPerformance;
